<template>
  <div id="app" class="container">
    <template v-if=user>
      <Word v-bind:wordRef="wordRef"/>
    </template>
    <template v-else>
      <button @click="signInWithGoogle">Sign in with Google</button>
    </template>
  </div>
</template>

<script>
import firebase from 'firebase';
import Word from './components/Word.vue';
const firebaseApp = firebase.initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET
});
const db = firebaseApp.database();

export default {
  name: 'app',
  beforeCreate: function() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      }
    })
  },
  data: function() {
    return {
      wordRef:  db.ref('vocabularies'),
      user: null,
    };
  },
  components: {
    Word
  },
  methods: {
    signInWithGoogle: function() {
      const provider = new firebase.auth.GoogleAuthProvider()
      firebase.auth().signInWithRedirect(provider).then((result) => {
        this.user = result.user
      }).catch(err => console.log(err))
    }
  }
}
</script>

<style>
#app {
}
</style>
